import { map, Observable } from 'rxjs';

// A pipe that transforms an observable of arrays by applying f to each element of each
// emitted array.
export function mapmap<T, U>(
  f: (x: T) => U,
): (xs: Observable<T[]>) => Observable<U[]> {
  return (ot) => ot.pipe(map((xs) => xs.map(f)));
}
